import { createSlice } from "@reduxjs/toolkit";

export const searchResultSlice = createSlice({
  name: "searchResult",
  initialState: {
    // null = No search result
    isSearchingCompleted: true,
    resultType: null,
    resultObject: null,
    viewingResult: null,
    cachedItemResult: {},
  },
  reducers: {
    setSearchType(state, action) {
      state.resultType = action.payload;
    },
    writeSearchResult(state, action) {
      state.resultObject = action.payload.resultObject;
    },
    rememberViewingResultItem(state, action) {
      state.viewingResult = action.payload;
      state.cachedItemResult = {};
    },
    cacheItemResult(state, action) {
      let { panelKey, data } = action.payload;
      state.cachedItemResult[panelKey] = data;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSearchType,
  writeSearchResult,
  rememberViewingResultItem,
  cacheItemResult,
} = searchResultSlice.actions;

export default searchResultSlice.reducer;
